import { render, staticRenderFns } from "./norm_page_cmp.vue?vue&type=template&id=0a388101&scoped=true&"
import script from "./norm_page_cmp.vue?vue&type=script&lang=js&"
export * from "./norm_page_cmp.vue?vue&type=script&lang=js&"
import style0 from "./norm_page_cmp.vue?vue&type=style&index=0&id=0a388101&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a388101",
  null
  
)

export default component.exports